/**
 * src/charts/bcr-v2/i18n.ts
 * Bar Chart Race V2 用の静的UIテキスト辞書
 */

// 辞書のキー定義（TypeScriptの型補完を効かせるため）
export interface BcrI18nDictionary {
    loadingMessage: string;
    step1Title: string;
    selectAllBtn: string;
    deselectAllBtn: string;
    confirmCategoryBtn: string;
    confirmCategoryBtnDisabled: string;
    step2Title: string;
    validDateRangeFormat: (start: string, end: string) => string;
    startDateLabel: string;
    endDateLabel: string;
    year: string;
    month: string;
    generateChartBtn: string;
    reselectCategoryBtn: string;
    noDataMessage: string;
    dateRangeError: string;
    // --- 後で追加する言語切り替えUI用 ---
    langSwitchLabel: string;
    applyLangBtn: string;
}

// 日本語 (デフォルト)
const ja: BcrI18nDictionary = {
    loadingMessage: "グラフを読み込んでいます...",
    step1Title: "ステップ① カテゴリを選択",
    selectAllBtn: "すべて選択",
    deselectAllBtn: "すべて解除",
    confirmCategoryBtn: "カテゴリを確定",
    confirmCategoryBtnDisabled: "カテゴリを1つ以上選択",
    step2Title: "ステップ② 期間を選択",
    validDateRangeFormat: (start, end) => `（データ有効期間: ${start} 〜 ${end}）`,
    startDateLabel: "開始",
    endDateLabel: "終了",
    year: "年",
    month: "月",
    generateChartBtn: "この期間でグラフを生成",
    reselectCategoryBtn: "カテゴリを再選択",
    noDataMessage: "表示するデータがありません。条件を変更して再度お試しください。",
    dateRangeError: "エラー: 終了年月は開始年月より後に設定してください。",
    langSwitchLabel: "Language",
    applyLangBtn: "適用",
};

// 英語
const en: BcrI18nDictionary = {
    loadingMessage: "Loading chart...",
    step1Title: "Step 1: Select Categories",
    selectAllBtn: "Select All",
    deselectAllBtn: "Deselect All",
    confirmCategoryBtn: "Confirm Categories",
    confirmCategoryBtnDisabled: "Select at least one",
    step2Title: "Step 2: Select Date Range",
    validDateRangeFormat: (start, end) => `(Valid Data Range: ${start} - ${end})`,
    startDateLabel: "Start",
    endDateLabel: "End",
    year: "/",
    month: "", // 英語表示の場合は YYYY/MM のようにするため、ラベルを調整
    generateChartBtn: "Generate Chart",
    reselectCategoryBtn: "Reselect Categories",
    noDataMessage: "No data available to display. Please change conditions and try again.",
    dateRangeError: "Error: End date must be after Start date.",
    langSwitchLabel: "Language",
    applyLangBtn: "Apply",
};

// 辞書マッピング
const dictionaries: { [key: string]: BcrI18nDictionary } = {
    ja,
    en,
};

/**
 * 指定された言語の辞書を取得する。
 * 存在しない言語が指定された場合は、デフォルト(ja)にフォールバックする。
 */
export function getI18nTexts(lang: string | null | undefined): BcrI18nDictionary {
    if (!lang) return dictionaries['ja'];
    
    // 小文字化して前方一致（例: 'en-US' -> 'en'）で判定
    const shortLang = lang.toLowerCase().substring(0, 2);
    return dictionaries[shortLang] || dictionaries['ja'];
}